export const ElevatorRunning = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      stroke="#363BC4"
      strokeMiterlimit="10"
      d="M9.169 8.634h.995m-2.997 0h1.001m2.998 0h1m-2.5 1.64V19m-6 0h12M4.663 7h10.004v12H4.662zm2.002 3.274h6V19h-6z"
    />
    <path
      stroke="#363BC4"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m18.042 12.5.75.75 1.5-1.5m1.375.75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
    />
  </svg>
);
